import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { bidAdjustmentFieldStyle } from './styles';
import { NumberStep } from '../components/NumberStep';
import { ChangeEvent, useState } from 'react';
import { FormProps, GenderFormValues } from '../../../../../../core/meta/model/bid-form.ts';

export const GenderForm: React.FC<FormProps<GenderFormValues>> = ({
  onChange,
  initialValues,
  disabled,
  excludeValues,
}) => {
  const [genderFormValues, setGenderFormValues] = useState<GenderFormValues>(
    initialValues || { gender: '', value: 1 }
  );
  const handleChange = (e: SelectChangeEvent<string> | ChangeEvent<HTMLInputElement>) => {
    const newValue =
      e.target instanceof HTMLInputElement ? parseFloat(e.target.value) : e.target.value;
    const newFormValue = { ...genderFormValues, [e.target.name]: newValue };
    setGenderFormValues(newFormValue);
    onChange(newFormValue);
  };

  const filteredGenders = ['male', 'female', 'default'].filter(
    (gender) => !excludeValues?.includes(gender)
  );

  return (
    <>
      <FormControl sx={bidAdjustmentFieldStyle}>
        <InputLabel>Gender</InputLabel>
        <Select
          name="gender"
          label="gender"
          onChange={handleChange}
          value={genderFormValues.gender}
        >
          {filteredGenders &&
            filteredGenders.map((gender) => (
              <MenuItem key={gender} value={gender}>
                {gender.toUpperCase()}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <NumberStep
        disabled={disabled}
        name="value"
        value={genderFormValues.value}
        onChange={handleChange}
      ></NumberStep>
    </>
  );
};
